<template>
  <div class="agreement-container">
    <div v-if="language === 'zh'" class="language-section">
      <h1 class="section-title">小额免密服务协议</h1>
      <p>
        小额免密服务协议（下称"本协议"）由CrestCard（下称"CrestCard"）与您签订，本协议是《CrestCard服务协议》的附属协议。您通过网络页面勾选或以其他方式选择接受本协议，即表示您与CrestCard已达成协议并同意接受本协议的全部约定内容。
      </p>
      <p>
        在使用小额免密功能（下称"本服务"）前，您应阅读并接受本协议、《CrestCard用户服务协议》。如果您不同意或者无法准确理解本协议条款的任意内容，请不要开启或使用本服务。您一经开启或使用本服务即视为对本协议的理解和接受。
      </p>
      <p>
        根据本协议，CrestCard将为您在CrestCard/H5/App（包括但不限于CrestCard下或关联品牌产品，下同）已开通卡支付服务基础上提供的更为便捷的小额免密服务。您在开通本服务后即不可撤销地授权CrestCard向您提供在一定额度及次数内免除密码、短信动态码以及其他任何信息验证的支付服务，具体额度以支付页面提示的额度为准；您点击本协议所在页面任意提示进行下一步的实体刷卡或线上支付时即不可撤销地向CrestCard系统发出指令，CrestCard系统将根据该指令从您的银行卡或其他可用于支付的账户中划扣资金。您可通过CrestCard
        APP或H5版本卡设置本服务的开通/关闭，实现本服务的开通/关闭。当您关闭本服务时，您将无法在线下或线上消费时实现小额免密支付。
      </p>
      <p>
        CrestCard有权根据客观情况和风险控制需要随时调整您的免密交易额度和次数，并对可疑交易进行拦截。无论CrestCard对您的免密交易额度和次数做何种调整，您均予以确认和接受。
      </p>
      <p>
        当您选择使用本服务时，CrestCard对于按照收到的上述符合约定的支付指令完成支付的行为不承担任何责任，您应妥善保管您的身份信息和银行卡号等账户信息以及与支付有关的所有信息和设备。如您遗失银行卡或泄露支付密码或其他个人身份信息或账户信息以及与支付有关的信息和设备，您应及时通过CrestCard
        APP申请冻结或注销等一系列措施，并及时通知CrestCard冻结CrestCard账
      </p>
      <p>
        任何通过您的CrestCard账号发起的本服务交易均视为您本人行为，由此导致的一切法律责任及损失均由您本人承担。您同意非因CrestCard的过错而导致的一切损失均由您自行承担。
      </p>
      <p>
        CrestCard对于本服务的后续改进升级，以及相关协议的修订，将在H5及App中或CrestCard网站相关页面上予以公示，不再另行单独通知您。您在本服务改进升级或本协议内容发生修订后，如继续使用本服务，即表明您接受了CrestCard的改进升级及相关协议的修订，如您不接受，请立即停止使用本服务。
      </p>
    </div>
    <div v-if="language === 'en'" class="language-section">
      <h1 class="section-title">
        Small-Amount Password-Free Service Agreement
      </h1>
      <p>
        This Small-Amount Password-Free Service Agreement (the "Agreement") is
        entered into by and between CrestCard (hereinafter referred to as
        "CrestCard") and you. This Agreement is an ancillary agreement to the
        CrestCard Service Agreement. By checking the box on the web page or
        otherwise selecting to accept this Agreement, you represent that you
        have reached an agreement with CrestCard and agree to be bound by all
        the terms herein.
      </p>
      <p>
        Before using the Small-Amount Password-Free Function (the "Service"),
        you should read and accept this Agreement and the CrestCard User Service
        Agreement. If you disagree with or cannot accurately understand any
        provisions of this Agreement, please do not activate or use the Service.
        Your activation or use of the Service constitutes your understanding and
        acceptance of this Agreement.
      </p>
      <p>
        Under this Agreement, CrestCard will provide you with a more convenient
        small-amount password-free payment service based on the card payment
        service already activated on CrestCard/H5/App (including but not limited
        to CrestCard and its affiliated brand products, the same below). After
        activating the Service, you irrevocably authorize CrestCard to provide
        payment services that waive password, SMS dynamic code, and any other
        information verification within a certain amount and number of
        transactions, with the specific limit as indicated on the payment page.
        When you click any prompt on the page where this Agreement is located to
        proceed with physical card swiping or online payment, you irrevocably
        issue an instruction to CrestCard's system, which will deduct funds from
        your bank card or other payable accounts in accordance with such
        instruction. You may activate or deactivate the Service through the card
        settings on the CrestCard APP or H5 version. When you deactivate the
        Service, you will no longer be able to use small-amount password-free
        payments for offline or online consumption.
      </p>
      <p>
        CrestCard reserves the right to adjust your password-free transaction
        limits and frequency at any time based on objective circumstances and
        risk control needs, and to intercept suspicious transactions. You
        confirm and accept any adjustments made by CrestCard to your
        password-free transaction limits and frequency.
      </p>
      <p>
        When you choose to use the Service, CrestCard shall not be liable for
        any payment on the basis of the above-described compliant payment
        instructions received. You should properly safeguard your identity
        information, bank card number, and all other account information related
        to payments, as well as all devices and information related to payments.
        If you lose your bank card, leak your payment password, other personal
        identity information, account information, or payment-related
        information and devices, you should promptly apply for freezing or
        cancellation through the CrestCard APP and notify CrestCard to freeze
        your CrestCard account.
      </p>
      <p>
        Any transaction initiated through your CrestCard account under this
        Service shall be deemed to be your own act, and you shall bear all legal
        liabilities and losses arising therefrom. You agree that all losses not
        caused by CrestCard's fault shall be borne by you alone.
      </p>
      <p>
        CrestCard will publicly announce any subsequent improvements, upgrades,
        or amendments to this Service and related agreements on the H5, App, or
        relevant pages of the CrestCard website, without separate notice to you.
        If you continue to use the Service after such new developments or
        amendments to this Agreement, you are deemed to have accepted such
        changes. If you do not accept them, please stop using the Service
        immediately.
      </p>
    </div>
    <div v-if="language === 'ja'" class="language-section">
      <h1 class="section-title">小額非暗号決済サービス契約</h1>
      <p>
        本小額非暗号決済サービス契約（以下「本契約」という）は、CrestCard（以下「CrestCard」という）と貴殿との間で締結されるもので、《CrestCard
        サービス契約》の附属契約です。貴殿がウェブページ上でチェックボックスを選択するか、その他の方法で本契約を受諾することにより、貴殿は
        CrestCard
        との間で契約を締結し、本契約の全ての約款に同意したものとみなします。
      </p>
      <p>
        小額非暗号機能（以下「本サービス」という）を利用する前に、貴殿は本契約及び《CrestCard
        ユーザーサービス契約》を読み、受諾する必要があります。本契約の条項のいずれかに同意できない場合、又は正確に理解できない場合には、本サービスの利用を開始しないでください。貴殿が本サービスの利用を開始した時点で、本契約を理解し、受諾したものとみなします。
      </p>
      <p>
        本契約に基づき、CrestCard は、貴殿が CrestCard/H5/App（CrestCard
        及び関連ブランド製品を含むが、これらに限定されない。以下同じ）で既にカード決済サービスを開通している状態を前提として、より便利な小額非暗号決済サービスを提供します。本サービスを開通した後、貴殿は、一定の限度額及び回数の範囲内で、パスワード、SMS
        動的認証コード並びにその他のいかなる情報認証も免除された決済サービスを受けるため、CrestCard
        に対して撤回不能に授権するものとし、具体的な限度額は決済ページに表示される額で確定します。本契約が記載されたページ上の任意のプロンプトをクリックして次の段階の実体カード決済又はオンライン決済を進める時点で、貴殿は
        CrestCard システムに対して撤回不能に指令を発行するものとし、CrestCard
        システムは当該指令に基づき、貴殿の銀行カード又はその他の決済可能なアカウントから資金を引き落とします。貴殿は、CrestCard
        アプリ又は H5
        バージョンのカード設定により、本サービスの開通／終了を設定することができます。本サービスを終了した場合、貴殿はオフライン又はオンラインの消費時に小額非暗号決済を利用することができなくなります。
      </p>
      <p>
        CrestCard
        は、客観的な状況及びリスク管理の必要性に基づき、いつでも非暗号取引の限度額及び回数を調整し、疑わしい取引を遮断する権利を有します。CrestCard
        が非暗号取引の限度額及び回数をいかなる形で調整した場合であっても、貴殿は当該調整を確認し、受諾するものとします。
      </p>
      <p>
        貴殿が本サービスを利用する場合、CrestCard
        は、上記の約定に適合した決済指令を受け取り、当該指令に基づいて決済を完了した行行为について一切の責任を負わないものとします。貴殿は、本人の身分情報、銀行カード番号等のアカウント情報、並びに決済に関連する一切の情報及び機器を適切に保管する必要があります。銀行カードの紛失、決済パスワードの漏洩、その他の個人身分情報又はアカウント情報、並びに決済に関連する情報及び機器の漏洩が生じた場合、貴殿は直ちに
        CrestCard アプリを通じて凍結又は解約などの一連の措置を申請し、かつ
        CrestCard に対して CrestCard アカウントの凍結を通知する必要があります。
      </p>
      <p>
        貴殿の CrestCard
        アカウントを通じて本サービスによる取引が行われた場合、当該取引はすべて貴殿本人による行為とみなされ、これに起因する一切の法律責任及一損失は貴殿本人が負担します。CrestCard
        の過失によらない場合に生じる一切の損失について、貴殿は自行で負担することに同意します。
      </p>
      <p>
        CrestCard
        は、本サービスの後続の改良・アップグレード及び関連契約の改定内容を、H5
        及びアプリ並びに CrestCard
        ウェブサイトの関連ページに公示することで、個別に貴殿に通知することなく済ませます。本サービスの改良・アップグレード又或本契約の内容に改定が生じた後、貴殿が引き続き本サービスを利用する場合、当該改良・アップグレード及び関連契約の改定内容を受諾したものとみなしま。改定内容に同意しない場合には、直ちに本サービスの利用を中止してください。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "AgreementDisplay",
  computed: {
    language() {
      return this.$route.query.language || "en";
    },
  },
};
</script>

<style scoped>
.agreement-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.section-title {
  text-align: center;
  padding: 20px 0;
  border-bottom: 2px solid #333;
  margin-bottom: 30px;
  font-size: 24px;
}

.language-section {
  margin-bottom: 50px;
}

.language-section p {
  line-height: 1.8;
  font-size: 16px;
  margin-bottom: 15px;
  text-indent: 2em; /* 中文段落首行缩进 */
}

/* 日文部分调整（可选，根据实际需要） */
.language-section[lang="ja"] p {
  text-indent: 0; /* 日文通常不首行缩进 */
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .agreement-container {
    padding: 15px;
  }

  .section-title {
    font-size: 20px;
    padding: 15px 0;
    margin-bottom: 20px;
  }

  .language-section p {
    font-size: 15px;
    line-height: 1.6;
    margin-bottom: 12px;
  }
}

/* 小屏幕手机适配 */
@media screen and (max-width: 375px) {
  .section-title {
    font-size: 18px;
  }

  .language-section p {
    font-size: 14px;
  }
}
</style>
